import * as React from 'react';

import { createService } from '../../utils';
import { Icon } from './components/Icon';

export const TopBetService = createService({
  subTitle: 'Максимум звонков',
  description: ['Быстрее результат', '4 фото и яркий заголовок', 'Выше всех в начале поиска'],
  dataName: 'TopService',
  bgColor: 'gradient',
  icon: <Icon />,
});
